<template>
    <div>
      <Header></Header>
        <!--第一版块-->
        <div class="trans-sec1">
            <div class="trans-head"><el-button type="primary" size="mini" @click="$router.back()">返回</el-button></div>
            <div class="trans-til">
                <span></span><i>短网址转换成功</i>
            </div>
            <div class="trans-tip">
<!--                <label class="c-tip" onclick="window.location='/login'">-->
<!--                    <el-alert  title="提示：游客和免费链接可能会有广告，并且无法修改原链接，如需稳定服务及修改原链接，请登录和购买访问包" type="warning" show-icon :closable="false"></el-alert>-->
<!--                </label>-->
                <label class="c-tip" onclick="window.location='/login'">
                    <el-alert  title="提示：免费链接可能有广告，如需更加稳定和无广告请登录后购买访问包，如需打印，请使用专属域名或自有域名生成，切勿使用共享域名，请咨询客服" type="warning" show-icon :closable="false"></el-alert>
                </label>
            </div>
            <div class="trans-opt">
                <div class="trs-web">
                    <span class="w-til">短网址：</span>
                    <span class="w-inp"><el-input v-model="newUrl" placeholder="短链接" readonly></el-input></span>
                    <span class="w-btn"><el-button type="primary" @click="copyUrl">点击复制</el-button></span>
                </div>
              <div style="padding:10px 20px;margin-left:120px;margin-top:20px;background:rgb(93, 173, 243);border-radius: 40px;border-top-left-radius: 0px;line-height:200%;display:inline-block; ">
                <router-link to="/tabs/buyDomain" style="color:#ffffff;font-weight: bolder" class="flex-row item-center">
                    <i class="el-alert__icon el-icon-warning mr5"></i>
                    推荐您使用专属域名，共享域名容易被其他用户违规导致所有失效! 尤其是打印二维码</router-link>
              </div>
                <div class="trs-qr">
                    <span class="w-til">二维码：</span>
                    <div class="w-cont">
                        <div class="qr-frame" style="position:relative;">
                            <div class="qr-code" ref="qrCode">
                                <img id="qr-img" src="https://static.ttdwz.cc/static/user/res/images/icon_qr.png" alt="二维码">
                            </div>
                            <div class="qr-download">
                                <el-button type="primary" plain @click="savePic">下载二维码</el-button>
                            </div>
                        </div>
                        <div class="ori-web">
                          <span>原网址:  </span>
                            <p>{{orgUrl}}<el-button style="font-size:12px;padding:6px 8px;" type="danger" @click="$router.push('/tabs/ckUrlList')">+点击加入自动检测拦截通知功能</el-button></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>


      <div class="about-main-box">
        <div class="about-box">
          <div class="index-title2">天天短网址的优势-数据统计</div>
          <div class="about-s"><div class="about-s-main"><i style="color:green;" class="iconfont icon-dwzzhexiantu"></i> <b>访问量统计</b> <p>可以精准统计链接的IP，UV,PV 等</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#a64ec6;" class="iconfont icon-dwzshuju"></i> <b>地域统计</b> <p>一目了然统计链接访问的地图省份地域</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#0B5E6D;" class="iconfont icon-dwzliebiao"></i> <b>客户端统计</b> <p>phone,安卓,mac ,windows等</p> </div> </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#6ea7d0;" class="iconfont icon-dwzbianji"></i> <b>浏览器统计</b> <p>chrome,QQ浏览器，uc浏览器，微博客户端等</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#0000ff;" class="iconfont icon-dwzchart-pie"></i> <b>运营商统计i</b> <p>统计网络电信运营商，如移动联通电信长城等</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#0b9108;" class="iconfont icon-dwzliebiao"></i> <b>高频IP统计</b> <p>统计列出top前10访问量最大的IP地址</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#d81e06;" class="iconfont icon-dwzmenu"></i> <b>访问记录明细</b> <p>所有访问记录呈现并永久保存到云端</p> </div> </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#491217;" class="iconfont icon-dwzzhexiantu"></i> <b>图标显示统计数据</b> <p>chrome,QQ浏览器，uc浏览器，微博客户端等</p></div>  </div>
          <div class="clear"></div>
          <div class="index-title2">天天短网址的优势-高级功能</div>
          <div class="about-s"><div class="about-s-main"><i style="color:#1c6a9e;" class="iconfont icon-dwzRectangleCopy38"></i> <b>单次批量转换</b> <p>一次可以批量转换几十条甚至上百条 </p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#6ea7d0;" class="iconfont icon-dwzRectangleCopy31"></i> <b>数量限制</b> <p>可转换的数量远高于同行</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#491217;" class="iconfont icon-dwzRectangleCopy33"></i> <b>多链接随机</b> <p>可多条链接随机设定和展示</p> </div> </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#4eccc4;" class="iconfont icon-dwzelectronics"></i> <b>智能策略-PC识别</b> <p>可设定电脑和手机打开不一样的链接</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#0F3A56;" class="iconfont icon-dwzRectangleCopy18"></i> <b>智能策略-移动设备识别</b> <p>可根据不同设备设定不一样的落地链接</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#0A246A;" class="iconfont icon-dwzRectangleCopy34"></i> <b>智能策略-地理位置策略</b> <p>可根据地理位置设定不同的链接</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#1AAD19;" class="iconfont icon-dwzcolumn-horizontal"></i> <b>智能策略-微信浏览器识别</b> <p>可在微信浏览器识别，并自定义访问</p> </div> </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#00a249;" class="iconfont icon-dwzRectangleCopy40"></i> <b>管理短网址</b> <p>可修改删除随时管理短链接</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#daa726;" class="iconfont icon-dwzRectangleCopy36"></i> <b>设置短网址访问密码</b> <p>可设置用户访问查看的密码</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#BD362F;" class="iconfont icon-dwzexport"></i> <b>修改短网址指向</b> <p>随时可自由修改源链接</p> </div> </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#00b800;" class="iconfont icon-dwzRectangleCopy38"></i> <b>高级功能-不同地区指向网址</b> <p>可根据不同区域设定不一样的落地链接</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#514721;" class="iconfont icon-dwzRectangleCopy10"></i> <b>高级功能-不同设备指向网址</b> <p>可根据不同设备设定不一样的落地链接</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#BD362F;" class="iconfont icon-dwzRectangleCopy"></i> <b>高级功能-提示浏览器打开</b> <p>可根据不同浏览器设定不一样的落地链接</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#0C5F9B;" class="iconfont icon-dwzcode"></i> <b>API接口转换</b> <p>可使用API接口批量转换</p></div>  </div>
          <div class="clear"></div>

        </div>
      </div>
        <!--第二版块-->
        <div class="trans-sec3 wrap ovf bgw mt20">
            <div class="reminder ovf">
                <h4 class="ts-til">温馨提示：</h4>
                <div class="desc ovf">
                    <p>1、短网址(Short URL)，形式上缩短网址，访问短网址可以跳转到原网址，用于微信自动回复、朋友圈、邮件营销、短信推广等处效果最佳</p>
                    <p>2、上面的二维码是根据短网址制作的，直接访问短网址和扫码二维码效果相同，用于图片推广、印刷推广，效果更佳</p>
                    <p>3、二维码为清晰型，可直接保存打印，打印版本二维码也可扫描，二维码纠错等级为H</p>
                    <p>4、不允许发布色情，赌博等违法信息，游客身份获取的链接不做保存，如需更多功能和稳定服务，请注册并登录</p>
                    <p>5、您可以将短网址分享给你的朋友，如需知道对方是否已经点击，请注册会员后再用</p>
                </div>
            </div>
            <div class="disclaimer ovf">
                <h4 class="ts-til">免责声明：</h4>
                <div class="desc ovf">
                    <p>1、本站免费使用! 专门提供短网址服务，短网址均由用户自主生成，所跳转网站内容均与本站无关!</p>
                    <p>2、其一切因使用本站短网址而可能遭致的意外、疏忽、侵权及其造成的损失（包括因下载被搜索链接到的第三方网站内容而感染电脑病毒），本站对其概不负责，亦不承担任何法律责任。</p>
                </div>
            </div>
        </div>
        <div class="footer ovf">Copyright &copy; 2018-2019  版权所有</div>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';
    import Header from "../header";
    export default {
        name: "Conversion",
      components: {Header},
      data() {
            return {
                isVip: false,
                isGuest: true,
                user_info: {},
                id: 0,
                newUrl: '',
                orgUrl: '',
            };
        },
        mounted() {
            const token = this.$storeLocal.get('token');
            const user_info = this.$storeLocal.get('userInfo');
            const times = Date.parse(new Date())/1000;
            const id = Number(this.$route.params.id);
            if (id === 0){
                this.$router.back();
                return;
            }
            this.id = id;
            if (token !== null && token !== '' && token !== undefined) {
                if (user_info.expire_date > times){
                    this.isVip = true;
                }
                this.isGuest = false;
                this.user_info = user_info;
            }

            setTimeout(this.getLinkInfo,200);
        },
        methods: {
            async getLinkInfo() {
                const {ret,data} = await this.$api.index.getLinkInfo({id:this.id});
                if (ret === 1000){
                    this.newUrl = data.newUrl;
                    this.orgUrl = data.orgUrl;
                    this.bindQRCode();
                }
            },
            bindQRCode() {
                const txt = this.newUrl+'?fr=qr';
                if (txt === '') return;
                this.$refs.qrCode.innerHTML = '';
                new QRCode(this.$refs.qrCode, {
                    text: txt,
                    width: 200,
                    height: 200,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                });
            },
            savePic() {
                let myQrCode = this.$refs.qrCode.getElementsByTagName('canvas');
                if (myQrCode.length === 0){
                    this.$message.error('下载失败！');
                    return;
                }
                let a = document.createElement('a');
                a.href = myQrCode[0].toDataURL('image/png');
                a.download = this.newUrl;
                a.click();
            },
            copyUrl() {
                const msg = this.$message;
                if (this.newUrl === ''){
                    msg.error('复制的内容为空！');
                    return;
                }
                this.$copyText(this.newUrl).then(function (e) {
                    msg.success('复制成功');
                }, function (e) {
                    msg.error('复制失败！');
                });
            }
        },
    }
</script>

<style scoped>

    .footer{
        color: #666666;
        text-align: center;
        line-height: 114px;
    }
    /*第一版块*/
    .trans-sec1{padding: 20px 60px 60px 60px;width:1080px;background-color: #FFFFFF;overflow: hidden;margin: 20px auto 0 auto;}
    .trans-head{width: 100%;height: 40px;text-align: right;}
    .trans-til{font-size: 0;text-align: center;}
    .trans-til span{background: url("../../assets/res/images/icon_dg.png") no-repeat;width: 40px;height: 40px;display: inline-block;margin-right: 20px;vertical-align: middle;}
    .trans-til i{font-size: 24px;font-style: normal;color: #07cc00;display: inline-block;vertical-align: middle;}
    .trans-tip{margin-top: 30px;padding: 0 100px;}
    .w-til{display: inline-block;width: 100px;height: 40px;font-size: 16px;color: #333;line-height: 40px;margin-right: 20px;text-align: right;vertical-align: top;}
    .w-inp{display: inline-block;width: 500px;height: 40px;vertical-align: top;}
    .w-btn{display: inline-block;width: 100px;height: 40px;margin-left: 20px;vertical-align: top;}
    .trans-opt{margin: 40px 170px 0 170px;}
    .trans-opt .trs-qr{margin-top: 35px;}
    .trans-opt .trs-qr .w-cont{display: inline-block;width: 420px;}
    .trans-opt .trs-qr .qr-code{display: inline-block;width: 200px;height: 200px;vertical-align: top;}
    .trans-opt .trs-qr .qr-code img{width: 100%;height: 100%;}
    .trans-opt .trs-qr .qr-download{display: inline-block;width: 200px;height: 200px;line-height: 200px;margin-left: 20px;vertical-align: top;}
    .trans-opt .trs-qr .ori-web{margin-top: 30px;color: #999;}
    .trans-opt .trs-qr .ori-web span{display: block;}
    .trans-opt .trs-qr .ori-web p{line-height: 24px;margin-top: 8px;word-break: break-all;}
    .trans-sec3{padding: 30px 40px;width: 1120px;background-color: #FFFFFF;overflow: hidden;margin: 20px auto 0 auto;font-size: 14px;}
    .trans-sec3 .ts-til{color: #333;}
    .trans-sec3 .desc{color: #666;line-height: 30px;margin-top: 8px;}

    .clear{clear: both;}
    .about-main-box{padding: 20px 60px 60px 60px;width:1080px;background-color: #FFFFFF;overflow: hidden;margin: 20px auto 0 auto;}
    .about-box{margin-top: 50px;}
    .about-box .index-title2{padding: 0px 0px;font-size: 14px;color:#333;margin-top:20px;font-weight: bolder;}
    .about-box .about-s{width:220px;margin-right:10px;float:left;background:#f4f7f369;height:90px;margin-top: 10px;}
    .about-box .about-s .about-s-main{padding:15px;}
    .about-box .title2{font-weight: bold;padding:20px 0;}
    .about-box .about-s b{font-size:14px;font-weight: bold;color:#727888;}
    .about-box i{font-size:20px;   }
    .about-box p{font-size: 14px;color: #727888;}
</style>
